module.exports = __webpack_public_path__ + "static/img/sticker-sale-2x1.3db8541.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/salepage/banner/sticker/sticker-sale-2x1.png
// module id = n5Hx
// module chunks = 134